import React, { useEffect, useState } from 'react';

/**
 * Başlıktaki canlı saat.
 *
 * Referans arayüzde başlığın sağ ucunda "TUR 10:38:51" biçiminde bir saat
 * durur ve **sunucunun değil oyuncunun** saatini değil, sitenin çalıştığı
 * dilim olan Türkiye saatini gösterir: canlı bahiste maç başlangıçları bu
 * dilime göre yazıldığı için tarayıcısı başka dilimde olan oyuncu aksi hâlde
 * saatleri yanlış okur.
 *
 * Dilim `Intl` ile sabitlenir; desteklenmeyen ortamda (çok eski tarayıcı,
 * jsdom) yerel saate düşülür — saat kaybolmaktansa yaklaşık doğru olsun.
 */
const TIME_ZONE = 'Europe/Istanbul';

const buildFormatter = () => {
  try {
    return new Intl.DateTimeFormat('tr-TR', {
      timeZone: TIME_ZONE,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  } catch {
    return null;
  }
};

export const formatClock = (date, formatter) => {
  if (formatter) return formatter.format(date);
  const pad = (value) => String(value).padStart(2, '0');
  return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const ParisClock = () => {
  const [formatter] = useState(buildFormatter);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="paris-clock" aria-label="Türkiye saati">
      <span className="paris-clock-zone">TÜR</span>
      <span className="paris-clock-time">{formatClock(now, formatter)}</span>
    </div>
  );
};

export default ParisClock;
